import paper, { Layer } from 'paper/dist/paper-core';

const Track = function( track ) {
    let _path;

    async function initialize() {
        const path = await new Promise( (resolve, reject) => {
            const layer = new Layer();
            layer.importSVG(track, (path, svg) => {
                resolve(path)
            });
        });

        path.strokeColor = 'transparent';
        path.fillColor = 'transparent';
        path.position = paper.view.center;

        _path = path.children['track'];
        
        paper.view.draw();
    }

    this.getPath = function () {
        return _path;
    }
   
    return (async () => {
        await initialize();
        return this;
    })();
}

export default Track;